module.exports = __webpack_public_path__ + "img/1500524090.441f2082.jpg";